import { currentDirection } from "@app/lib/helper";
import { cn } from "@app/lib/utils";
import { Button } from "@design-system/components";
import { useEffect, useState } from "react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";

type YearsTabsProps = {
  years: number[];
  onChange: (year: number | null) => void;
};

export function YearsTabs({ years, onChange }: YearsTabsProps) {
  const [activeYear, setActiveYear] = useState<number>(years?.[0] || 0);

  const handleYearChange = (year: number) => {
    setActiveYear(year);
    onChange(year);
  };

  useEffect(() => {
    if (years && years.length > 0) {
      handleYearChange(years[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [years]);

  return (
    <YearsSlider>
      {years.map((year) => (
        <SwiperSlide key={year} className="max-w-fit">
          <Button
            key={year}
            variant="outline"
            className={cn(
              "rounded-full border px-4 py-2 text-xs leading-none bg-marine hover:bg-tech-blue hover:border-tech-blue text-white focus:outline-none focus:outline-0 focus:ring-0 focus:ring-transparent md:min-w-[90px] md:text-base",
              activeYear === year
                ? "border-bright-orange text-white bg-bright-orange hover:bg-bright-orange hover:border-bright-orange"
                : "",
            )}
            onClick={() => handleYearChange(year)}
          >
            <span className="inline-block ltr:mt-1">{year}</span>
          </Button>
        </SwiperSlide>
      ))}
    </YearsSlider>
  );
}

type YearsSliderProps = {
  children: React.ReactNode;
};

function YearsSlider({ children }: YearsSliderProps) {
  const dir = currentDirection();

  return (
    <Swiper
      className="w-full !p-2 transition-none"
      slidesPerView="auto"
      spaceBetween={8}
      dir={dir}
      key={dir}
    >
      {children}
    </Swiper>
  );
}
